import React from 'react';
import { TagV2, TagV2Variant, TagV2Size } from '@zola/zola-ui/src/components/Tag/TagV2';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';

const MatchThemeTag = ({
  className,
  greenVersion = false,
}: {
  className?: string;
  greenVersion?: boolean;
}): JSX.Element =>
  greenVersion ? (
    <TagV2
      variant={TagV2Variant.GREEN}
      className={className}
      size={TagV2Size.LARGE}
      css={{ color: COLORS3.BLACK_100 }}
    >
      Matches your website
    </TagV2>
  ) : (
    <TagV2
      variant={TagV2Variant.WHITE}
      size={TagV2Size.LARGE}
      emoji={{ symbol: '⭐️', alt: 'star emoji' }}
      className={className}
    >
      Matches your website
    </TagV2>
  );

export default MatchThemeTag;
